<div class="login-page-fullscreen-wrapper split-view-layout">
  <div class="weather-isolines-overlay"></div>

  <div
    class="login-split-side-hero"
    style="background-image: url('../../assets/images/authscreen.jpg')">
  </div>

  <div
    class="login-split-side-form-container theme-light-split"
    data-theme="light">
    <mat-card
      appearance="outlined"
      class="login-glass-card anim-fade-up-2 is-frost-glass">
      <div class="login-language-wrapper">
        <button
          mat-icon-button
          class="language-toggle-btn-glass"
          [matMenuTriggerFor]="menuTranslate"
          type="button">
          <img
            class="u-responsive-flag-img"
            src="assets/images/flags/{{ language() }}.png"
            [alt]="'HOME.LANGUAGE' | translate" />
        </button>
      </div>

      @let errorMessageValue = errorMessage();
      @let wantNewPasswordValue = wantNewPassword();
      @let forgotPasswordValue = forgotPassword();
      @let loginErrorValue = loginError();
      @let loginErrorUserValue = loginErrorUser();
      @let loginErrorMessageValue = loginErrorMessage();
      @let signInIsRunningValue = signInIsRunning();

      <!-- ========================================================================== -->
      <!-- CORE ANMELDE-PFAD                                                          -->
      <!-- ========================================================================== -->
      @if (!wantNewPasswordValue && !forgotPasswordValue) {
        <!--<mat-card-header class="login-card-header">
          <mat-card-title class="login-form-card-title">Portal-Anmeldung</mat-card-title>
          <mat-card-subtitle class="login-form-card-subtitle"
            >Bitte authentifizieren Sie sich mit Ihren
            Zugangsdaten</mat-card-subtitle
          >
        </mat-card-header>-->

        <mat-card-content class="login-card-body">
          <form
            [formGroup]="loginForm"
            (ngSubmit)="signIn()"
            class="login-native-form">
            <!-- Feld: Benutzername -->
            <mat-form-field appearance="fill" class="login-input-field">
              <mat-label>{{ 'LOGIN.email' | translate }}</mat-label>
              <input
                matInput
                id="email"
                formControlName="username"
                autofocus
                autocomplete="username"
                required />
              <fa-icon
                matSuffix
                [icon]="['far', 'user']"
                class="input-suffix-icon"></fa-icon>
            </mat-form-field>

            <!-- Feld: Passwort -->
            @let hidePasswordValue = hidePassword();
            <mat-form-field appearance="fill" class="login-input-field">
              <mat-label>{{ 'LOGIN.password' | translate }}</mat-label>
              <input
                matInput
                id="password"
                autocomplete="current-password"
                [type]="hidePasswordValue ? 'password' : 'text'"
                formControlName="password"
                required />
              <button
                mat-icon-button
                matSuffix
                type="button"
                class="password-eye-toggle-btn"
                (click)="hidePassword.set(!hidePasswordValue)">
                <fa-icon
                  [icon]="['far', hidePasswordValue ? 'eye' : 'eye-slash']"
                  class="input-suffix-icon"></fa-icon>
              </button>
            </mat-form-field>

            <!-- Sektion: Datenschutz -->
            <div class="login-privacy-consent-line">
              <mat-checkbox
                #privacyCheck
                [checked]="alreadyCheckedPrivacy()"
                class="custom-color-checkbox login-privacy-check">
                <span class="privacy-label-text">
                  {{ 'LOGIN.PRIVACY.TEXT1' | translate }}
                  <a
                    href="{{ 'LOGIN.PRIVACY.LINK' | translate }}"
                    target="_blank"
                    class="privacy-link-inline">
                    {{ 'LOGIN.PRIVACY.TEXT2' | translate }}
                  </a>
                  {{ 'LOGIN.PRIVACY.TEXT3' | translate }}
                </span>
              </mat-checkbox>
            </div>

            <!-- Aktionszeile -->
            <div class="login-actions-toolbar-row">
              <button
                mat-button
                class="btn-app-back login-forgot-btn-flat"
                type="button"
                [disabled]="signInIsRunningValue"
                (click)="askForNewPassword()">
                {{ 'LOGIN.forgotPassword' | translate }}
              </button>

              @if (!signInIsRunningValue) {
                <button
                  class="btn-app-save login-submit-btn-flat"
                  type="submit"
                  [disabled]="
                    !privacyCheck.checked ||
                    signInIsRunningValue ||
                    (loginFormInvalid() && loginFormTouched())
                  ">
                  <span>{{ 'LOGIN.login' | translate }}</span>
                  <fa-icon [icon]="['far', 'sign-in-alt']"></fa-icon>
                </button>
              }
            </div>

            <!-- SYSTEM ERROR FEEDBACK BOX -->
            @if (
              loginErrorValue || loginErrorUserValue || loginErrorMessageValue
            ) {
              <div class="login-error-feedback-summary-box">
                <fa-icon
                  [icon]="['far', 'exclamation-circle']"
                  class="error-summary-icon"></fa-icon>
                <div class="error-summary-text-lines">
                  @if (loginErrorValue) {
                    <p class="error-msg-p">
                      {{ 'LOGIN.wrongPassword1' | translate }}
                    </p>
                    <p class="error-msg-p">
                      {{ 'LOGIN.wrongPassword2' | translate }}
                    </p>
                  }
                  @if (loginErrorUserValue) {
                    <p class="error-msg-p">
                      {{ 'LOGIN.wrongUserName' | translate }}
                    </p>
                  }
                  @if (loginErrorMessageValue) {
                    <p class="error-msg-p">
                      {{ 'LOGIN.wrongPassword1' | translate }}
                    </p>
                    <p class="error-msg-p support-mail-line">
                      {{ 'LOGIN.wrongPassword2' | translate }}
                      <a
                        href="mailto:einsatzwetter@wettermanufaktur.de"
                        class="error-inline-link"
                        >einsatzwetter&#64;wettermanufaktur.de</a
                      >
                    </p>
                  }
                </div>
              </div>
            }
          </form>
        </mat-card-content>
      }

      @if (wantNewPasswordValue) {
        <mat-card-content class="login-card-body">
          @let limitExceptionValue = limitException();
          @let accountNotActiveValue = accountNotActive();

          <form [formGroup]="newPasswordForm" class="login-native-form">
            <!-- Logo & Titel analog zum Hero-Style, aber dezent für Light-Mode -->
            <div class="form-header-center-box">
              <h1 class="form-main-title">
                {{ 'LOGIN.EINSATZWETTER' | translate }}
              </h1>
            </div>

            <!-- Hinweistexte -->
            <div class="form-info-text-block">
              <p class="info-text-p">
                {{ 'LOGIN.newPasswordRequest1' | translate }}
              </p>
              <p class="info-text-p sub-p">
                {{ 'LOGIN.newPasswordRequest2' | translate }}
              </p>
            </div>

            <!-- Feld: E-Mail / Benutzername -->
            <mat-form-field appearance="fill" class="login-input-field">
              <mat-label>{{ 'LOGIN.email' | translate }}</mat-label>
              <input
                matInput
                id="email-reset"
                formControlName="username"
                autofocus
                autocomplete="username"
                required />
              <fa-icon
                matSuffix
                [icon]="['far', 'envelope']"
                class="input-suffix-icon"></fa-icon>
            </mat-form-field>

            <!-- Aktionszeile (Buttons analog zum Login) -->
            <div class="login-actions-toolbar-row">
              <button
                mat-button
                class="btn-app-back login-forgot-btn-flat"
                type="button"
                (click)="wantNewPassword.set(false)">
                {{ 'SETTINGS.CANCEL' | translate }}
              </button>

              <button
                class="btn-app-save login-submit-btn-flat"
                type="submit"
                (click)="triggerWantedPassword()">
                <span>{{ 'LOGIN.newPasswordWanted' | translate }}</span>
                <fa-icon [icon]="['far', 'paper-plane']"></fa-icon>
              </button>
            </div>
          </form>

          <!-- SYSTEM ERROR FEEDBACK BOX (Gleicher Style wie beim Login) -->
          @if (
            accountNotActiveValue || limitExceptionValue || loginErrorValue
          ) {
            <div class="login-error-feedback-summary-box">
              <fa-icon
                [icon]="['far', 'exclamation-circle']"
                class="error-summary-icon"></fa-icon>
              <div class="error-summary-text-lines">
                @if (accountNotActiveValue) {
                  <p class="error-msg-p">
                    {{ 'LOGIN.accountNotActive' | translate }}
                  </p>
                }

                @if (limitExceptionValue) {
                  <p class="error-msg-p">
                    {{ 'LOGIN.limitException' | translate }}
                  </p>
                }

                @if (loginErrorValue) {
                  <p class="error-msg-p">{{ errorMessageValue }}</p>
                }

                <!-- Generischer Zusatztext mit Support-Button -->
                <p class="error-msg-p support-action-line">
                  {{ 'LOGIN.wrongPassword2' | translate }}
                </p>

                <button
                  mat-button
                  class="error-support-btn"
                  (click)="onContact()">
                  <fa-icon [icon]="['far', 'comment-alt-lines']"></fa-icon>
                  {{ 'HOME.CONTACT' | translate }}
                </button>
              </div>
            </div>
          }
        </mat-card-content>
      }

      @if (forgotPasswordValue) {
        <mat-card-content class="login-card-body">
          @let passwordArrayValue = passwordArray();
          @let resetPasswordWithoutCodeValue = resetPasswordWithoutCode();

          <form [formGroup]="forgotPasswordForm" class="login-native-form">
            <!-- Header-Bereich (Exakt wie in den anderen Masken) -->
            <div class="form-header-center-box">
              <h1 class="form-main-title">
                {{ 'LOGIN.EINSATZWETTER' | translate }}
              </h1>
            </div>

            <!-- Informations- und Status-Texte -->
            <div class="form-info-text-block">
              @if (expiredPassword()) {
                <p class="info-text-p warning-highlight-text">
                  {{ 'LOGIN.expiredPassword' | translate }}
                </p>
              }
              <p class="info-text-p">
                {{ 'LOGIN.resetPasswordRequest1' | translate }}
              </p>

              @if (!resetPasswordWithoutCodeValue) {
                <p class="info-text-p sub-p">
                  {{ 'LOGIN.resetPasswordRequest2' | translate }}
                </p>
                <p class="info-text-p sub-p">
                  {{ 'LOGIN.resetPasswordRequest3' | translate }}
                </p>
              }

              <div class="user-email-badge">
                <fa-icon [icon]="['far', 'user']"></fa-icon>
                <span
                  >{{ 'LOGIN.email' | translate }}:
                  <strong>{{ userName() }}</strong></span
                >
              </div>
            </div>

            <!-- Feld: Code (wird nur angezeigt, wenn Code erforderlich ist) -->
            @if (!resetPasswordWithoutCodeValue) {
              <mat-form-field appearance="fill" class="login-input-field">
                <mat-label>{{
                  'LOGIN.forgotPasswordCode' | translate
                }}</mat-label>
                <input
                  matInput
                  id="code"
                  type="number"
                  formControlName="code"
                  autocomplete="new-code"
                  required />
                <fa-icon
                  matSuffix
                  [icon]="['far', 'key']"
                  class="input-suffix-icon"></fa-icon>
              </mat-form-field>
            }

            <!-- Feld: Neues Passwort -->
            <mat-form-field appearance="fill" class="login-input-field">
              <mat-label>{{ 'LOGIN.newPassword' | translate }}</mat-label>
              <input
                matInput
                id="forgotPasswordNew"
                type="password"
                formControlName="passwordNew"
                autocomplete="new-password"
                required />
              <fa-icon
                matSuffix
                [icon]="['far', 'lock']"
                class="input-suffix-icon"></fa-icon>
            </mat-form-field>

            <!-- Passwort-Anforderungen / Kriterien-Liste -->
            <div class="password-requirements-container">
              <ul class="requirements-list">
                <li
                  [class.requirement-success]="passwordArrayValue[0]"
                  class="requirement-item">
                  <fa-icon
                    [icon]="[
                      'far',
                      passwordArrayValue[0] ? 'check-circle' : 'circle',
                    ]"
                    class="req-icon"></fa-icon>
                  <span>{{
                    'LOGIN.passwordRequirements.number' | translate
                  }}</span>
                </li>
                <li
                  [class.requirement-success]="passwordArrayValue[1]"
                  class="requirement-item">
                  <fa-icon
                    [icon]="[
                      'far',
                      passwordArrayValue[1] ? 'check-circle' : 'circle',
                    ]"
                    class="req-icon"></fa-icon>
                  <span>{{
                    'LOGIN.passwordRequirements.smallLetters' | translate
                  }}</span>
                </li>
                <li
                  [class.requirement-success]="passwordArrayValue[2]"
                  class="requirement-item">
                  <fa-icon
                    [icon]="[
                      'far',
                      passwordArrayValue[2] ? 'check-circle' : 'circle',
                    ]"
                    class="req-icon"></fa-icon>
                  <span>{{
                    'LOGIN.passwordRequirements.bigLetters' | translate
                  }}</span>
                </li>
                <li
                  [class.requirement-success]="passwordArrayValue[3]"
                  class="requirement-item">
                  <fa-icon
                    [icon]="[
                      'far',
                      passwordArrayValue[3] ? 'check-circle' : 'circle',
                    ]"
                    class="req-icon"></fa-icon>
                  <span>{{
                    'LOGIN.passwordRequirements.sonder' | translate
                  }}</span>
                </li>
                <li
                  [class.requirement-success]="passwordArrayValue[4]"
                  class="requirement-item">
                  <fa-icon
                    [icon]="[
                      'far',
                      passwordArrayValue[4] ? 'check-circle' : 'circle',
                    ]"
                    class="req-icon"></fa-icon>
                  <span>{{
                    'LOGIN.passwordRequirements.length' | translate
                  }}</span>
                </li>
              </ul>
            </div>

            <!-- Aktionszeile (Rechtsbündiger primärer Button analog zum Login) -->
            <div class="login-actions-toolbar-row single-right-action">
              <button
                class="btn-app-save login-submit-btn-flat"
                type="submit"
                (click)="
                  resetPasswordWithoutCodeValue
                    ? changePassword()
                    : handleForgotPassword()
                "
                [disabled]="!passwordValid()">
                <span>{{ 'LOGIN.save' | translate }}</span>
                <fa-icon [icon]="['far', 'save']"></fa-icon>
              </button>
            </div>
          </form>

          <!-- SYSTEM ERROR FEEDBACK BOX (Gleicher Style wie beim Login & Reset) -->
          @if (loginErrorValue) {
            <div class="login-error-feedback-summary-box">
              <fa-icon
                [icon]="['far', 'exclamation-circle']"
                class="error-summary-icon"></fa-icon>
              <div class="error-summary-text-lines">
                <p class="error-msg-p">
                  {{ 'LOGIN.wrongCode' | translate }}
                </p>

                <!-- IT-Debug / Technische Fehlermeldung sauber formatiert im Error-Kasten -->
                <div class="error-it-debug-zone">
                  <span class="debug-label">System-Log:</span>
                  <p class="debug-msg">{{ errorMessageValue }}</p>
                </div>
              </div>
            </div>
          }
        </mat-card-content>
      }

      <mat-card-footer class="login-card-footer">
        <span class="copyright-text">© 2026 {{ 'HOME.WM' | translate }}</span>
      </mat-card-footer>
    </mat-card>
  </div>

  <!-- Menu language -->
  <mat-menu #menuTranslate="matMenu">
    <button mat-menu-item (click)="changeLanguage('de'); translate.use('de')">
      <img
        src="assets/images/flags/de.png"
        [alt]="'HOME.GERMAN' | translate" />&nbsp;
      <span>{{ 'HOME.GERMAN' | translate }}</span>
    </button>
    <button mat-menu-item (click)="changeLanguage('nl'); translate.use('nl')">
      <img
        src="assets/images/flags/nl.png"
        [alt]="'HOME.DUTCH' | translate" />&nbsp;
      <span>{{ 'HOME.DUTCH' | translate }}</span>
    </button>
    <button mat-menu-item (click)="changeLanguage('us'); translate.use('us')">
      <img
        src="assets/images/flags/us.png"
        [alt]="'HOME.ENGLISH' | translate" />&nbsp;
      <span>{{ 'HOME.ENGLISH' | translate }}</span>
    </button>
    <button mat-menu-item (click)="changeLanguage('fr'); translate.use('fr')">
      <img
        src="assets/images/flags/fr.png"
        [alt]="'HOME.FRENCH' | translate" />&nbsp;
      <span>{{ 'HOME.FRENCH' | translate }}</span>
    </button>
    <button mat-menu-item (click)="changeLanguage('es'); translate.use('es')">
      <img
        src="assets/images/flags/es.png"
        [alt]="'HOME.SPANISH' | translate" />&nbsp;
      <span>{{ 'HOME.SPANISH' | translate }}</span>
    </button>
    <button
      mat-menu-item
      (click)="changeLanguage('es-ct'); translate.use('es-ct')">
      <img
        src="assets/images/flags/es-ct.png"
        [alt]="'HOME.CATALAN' | translate" />&nbsp;
      <span>{{ 'HOME.CATALAN' | translate }}</span>
    </button>
    <button
      mat-menu-item
      (click)="changeLanguage('ch-de'); translate.use('ch-de')">
      <img
        src="assets/images/flags/ch-de.png"
        [alt]="'HOME.SWISSGERMAN' | translate" />&nbsp;
      <span>{{ 'HOME.SWISSGERMAN' | translate }}</span>
    </button>
  </mat-menu>
</div>
